import React, { FC, ReactNode } from 'react'

interface ProductItemHelperTextProps {
  text: ReactNode
}

const ProductItemHelperText: FC<ProductItemHelperTextProps> = ({ text }) => {
  return <span className="c-danger f6 pv3">{text}</span>
}

export default ProductItemHelperText
